<template>
  <div class="app-container">
    <!-- 查询条件区域 -->
    <!-- <el-collapse   v-model="activeName" accordion>
      <el-collapse-item :name="1">
        <template slot="title">
          <div class="title-container" shadow="never">
            <div class="title-con">
              <i class="el-icon-search"></i>
              <span style="margin-left: 5px;">筛选搜索</span>
            </div>
          </div>
        </template>
      <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
          <div class="filter-container" style="margin-top: 10px ;">
            <el-form :inline="true" :model="queryParam" label-width="140px">
              <el-form-item label="标签名称:">
                <el-input v-model="queryParam.name" placeholder="标签名称"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="button-container" style="margin-top: 0px">
            <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh" @click="handleResetSearch()">重 置</el-button>
            <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
          </div>
        </el-card>
      </el-collapse-item>

    </el-collapse>  -->


    <!--    查询结果区域-->
    <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-circle-plus-outline" @click="handleCreateOne()">新增</el-button>
      </div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table
        :data="tableData"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        v-loading="listLoading"
        ref="seleteTable"
        max-height="650"
        border>
        <el-table-column prop="name" label="类型名称" ></el-table-column>
        <el-table-column prop="createTime" label="创建时间" ></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" ></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="primary" plain size="small">修改</el-button>
            <el-button @click="handleDeleteOne(scope.row)" type="danger" plain size="small">删除</el-button>
            <!-- <el-button @click="handleUpdateOneDlg(scope.row)" type="danger" plain size="small">修改</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="queryParam.pageNum"
              :page-size="queryParam.pageSize"
              :page-sizes="queryParam.pageSizes"
              :total="queryParam.totalPage">
      </el-pagination>
    </div>
    <el-dialog
            title="添加类型"
            :visible.sync="visibleDlgAdd"
            width="50%"
            center>
      <div>
        <el-form  ref="addForm"  :model="addParam" :rules="rules" label-width="150px">
          <el-form-item  label="类型名称" prop="name" >
            <el-input v-model="addParam.name" placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgAdd = false">取消</el-button>
        <el-button type="primary" @click="handleAddOne">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog
            title="修改类型"
            :visible.sync="visibleEditDlg"
            width="50%"
            center>
      <div>
        <el-form  ref="editForm"  :model="editParam" :rules="rules" label-width="150px">
          <el-form-item  label="类型名称" prop="name" >
            <el-input v-model="editParam.name" placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleEditDlg = false">取消</el-button>
        <el-button type="primary" @click="handleEditOne">更新</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }
</style>

<script>
  import globaldata from "../../../utils/globaldata";
  import commonUtils from "../../../utils/commonUtils";
  import {photoTypeList,photoTypeAdd,photoTypeInActiveById,photoTypeUpdate} from "../../../api/storeFrontPhotoType";
  import {getStaticData} from "@/api/staticData";
  import messageUtils from "../../../utils/messageUtils";
  import { getToken } from '@/utils/auth'
  export default {
    components:{},
    data() {
      return {
        fileList:[],
        srcList:[],
        videoFileList:[],
        visitPicList:[],
        refreVisitPic:"",
        uploadAction:'',
        importHeaders:'',
        listLoading: true,
        storeFrontId:globaldata.getAdminStore().storeFrontId,
        //查询参数
        queryParam: {
          //分页查询
          pageNum :1 ,//当前第几页
          pageSize : 10,
        },
        totalPage :1, //总共页数
        pageSizes:[20,50,100],
        //查询区域默认展开
        activeName:1,
        createParam :{
        },
        //删除
        deleteParam :{
        },
        addParam:{
          name:'',
          showSearchFlag :false,
          storeFrontId:globaldata.getAdminStore().storeFrontId,
        },
        editParam:{
        },
        //弹窗
        visibleDlgAdd: false,
        visibleEditDlg:false,
        //表单结果
        tableData: [
        ],
        allWorker:[],
     
        rules:{
          name:[{required:true,message:"类型名称不能为空",trigger:"blur"}],
        },
      }


    },
    created(){
      this.fitchList()
      let mytoken = getToken();
      this.importHeaders  = {"Authorization": mytoken}
      getStaticData("").then(response =>
        {
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.uploadAction = data.uploadChildPhotoImageUrl+'/'+this.storeFrontId;
        })
    },
    mounted() {

    },
    methods: {
      statusFormatter(row, column, cellValue, index){
        if (cellValue==='1'){
          return '有效';
        }else{
          return '无效'
        }
      },
      booleanFormatter(row, column, cellValue, index){
        if (cellValue){
          return '是';
        }else{
          return '否'
        }
      },
      handleResetSearch(){
        this.queryParam={}
      },
      //点击查询按钮
      onBtnSearch() {
        this.fitchList();
      },
      handleCurrentChange(val) {
        this.queryParam.pageNum = val;
        this.fitchList();
      },
      handleSizeChange(val) {
        this.queryParam.pageSize = val;
        this.fitchList();
      },
      refreshData(list){
        this.tableData = list;
      },
      //添加一个
      handleCreateOne(){
        this.visibleDlgAdd = true;
      },
      onBtnOK(){
        this.visibleDlg = false;
        this.fitchList();
      },
     
      onBtnCancel(){
        this.visibleDlg = false;
      },

      handleEdit(row){
        this.visibleEditDlg = true;
        this.editParam = row
      },
      //刪除
      handleDeleteOne(row){
        this.$confirm('是否确认删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',

        }).then(() => {
          let param = {
            id:row.id,
          }
          photoTypeInActiveById(param).then(response => {
            let code = response.code;
            if (code == 20000){
              messageUtils.successMsg(this,response.message);
              this.fitchList();
            }else {
              messageUtils.errorMsg(this,response.message);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      fitchList(){
        this.listLoading = true;
        this.queryParam.storeFrontId = this.storeFrontId
        photoTypeList(this.queryParam).then(response => {
          this.listLoading = false;
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.queryParam.totalPage = data.total;

          this.refreshData(data.records);
        })
      },

      handleEditOne(){
        this.$refs['editForm'].validate(valid=>{
          if(valid){
            photoTypeUpdate(this.editParam).then(response =>
            {
              let code = response.code;
              if (code == 20000){
                messageUtils.successMsg(this,response.message);
                this.visibleEditDlg= false;
                this.fitchList();
              }else {
                messageUtils.errorMsg(this,response.message);
              }
            })
            this.addParam={}
          }
        })
      },
     
      handleAddOne() {
        this.$refs['addForm'].validate(valid=>{
          if(valid){
            photoTypeAdd(this.addParam).then(response =>
            {
              let code = response.code;
              if (code == 20000){
                messageUtils.successMsg(this,response.message);
                this.visibleDlgAdd= false;
                this.fitchList();
              }else {
                messageUtils.errorMsg(this,response.message);
              }
            })
            this.addParam={}
          }
        })
      },
    }
  }



</script>






// WEBPACK FOOTER //
// src/views/my-store/photo-type/index.vue